import pako from 'pako';

export class CrossPlatformCompressorJS {
  static fieldMap = new Map([
    ['utm_source', 's'],
    ['utm_medium', 'm'],
    ['utm_campaign', 'c'],
    ['utm_content', 'ct'],
    ['utm_term', 't'],
    ['utm_id', 'i'],
    ['utm_cid', 'cd'],
    ['gad_source', 'g'],
    ['gclid', 'gl'],
    ['fbclid', 'fb'],
    ['msclkid', 'ms'],
  ]);
  static encodeValueMap = new Map([
    ['__', '~'],
    ['google', 'g'],
    ['facebook', 'fb'],
    ['twitter', 'tw'],
    ['newsletter', 'nl'],
    ['cpc', 'c'],
    ['organic', 'o'],
    ['email', 'e'],
    ['social', 's'],
    ['banner', 'bn'],
    ['text_link', 'tl'],
    ['video_ad', 'va'],
    ['spring_sale', 'ss'],
    ['black_friday', 'bf'],
    ['holiday_special', 'hs'],
    ['Cj0KCQjw_', 'gcl:'],
    ['AX2g_', 'fcl:'],
    ['45g_', 'mscl:'],
  ]);
  static encode(data: Record<string, string>) {
    const simplified: Record<string, string> = {};
    Array.from(this.fieldMap.keys()).forEach((originalKey) => {
      if (data[originalKey]) {
        const newKey = this.fieldMap.get(originalKey);
        if (newKey) {
          simplified[newKey] = this.compressValue(data[originalKey]);
        }
      }
    });
    const sortedKeys = Object.keys(simplified).sort();
    const sortedObj: Record<string, string> = {};
    sortedKeys.forEach((k) => (sortedObj[k] = simplified[k]));
    const jsonStr = JSON.stringify(sortedObj);
    // Use direct compression on jsonStr with fixed level 9
    const compressed = pako.gzip(jsonStr);
    // Base62 encoding
    return this.base62Encode(compressed);
  }
  static compressValue(value: string) {
    for (const [k, v] of this.encodeValueMap) {
      if (value.toLowerCase() === k.toLowerCase()) return v;
    }
    for (const [k, v] of this.encodeValueMap) {
      if (k.endsWith('_') && value.startsWith(k)) {
        return v + value.slice(k.length);
      }
    }
    if (/^\d+$/.test(value)) {
      return this.compressNumber(value);
    }
    return value;
  }
  static compressNumber(numStr: string) {
    const len = numStr.length;
    if (len > 8) {
      return `${numStr.slice(0, 4)}__${numStr.slice(4, -4)}__${numStr.slice(
        -4
      )}`;
    }
    if (len > 4) {
      return `${numStr.slice(0, 4)}__${numStr.slice(4)}`;
    }
    return numStr;
  }
  static base62Encode(buffer: Uint8Array) {
    const BASE62 =
      '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';
    const hexString = Array.from(buffer)
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
    // Add '0x' to the start of the string to indicate it's hexadecimal
    const bigIntParam = '0x' + hexString;
    // Create BigInt from the hexadecimal string
    let number = BigInt(bigIntParam);
    while (number > 0n) {
      const remainder = number % 62n;
      result = BASE62[Number(remainder)] + result;
      number = number / 62n;
    }
    return result || '0';
  }
}
